import { IkeToken } from '@ikegps/core-api';
import { ModalFormComponent } from '../../components/modal.form/modal.form.component';
import { NotificationService } from '../../components/notification.toast/notification.service';
import { T, Translate } from '../../i18n/index';
import type { MithrilVNode } from '../../mithril';
import { Services } from '../../services/index';
import { m } from '../../services/render.service';
import { CurrentState } from '../../state/page.state';

/** Protect users from deleting all of their data */
const MAX_TAG_COUNT = 5;

export const CollectionDeleteCtrl = {
	get selectedCount() {
		return CurrentState.Tag.collections.length;
	},

	canDisplay(): boolean {
		return Services.Token.has(IkeToken.COLLECTION_DELETE);
	},

	canDelete(): boolean {
		if (!CollectionDeleteCtrl.canDisplay()) {
			return false;
		}

		const selectedTagIds = CurrentState.Tag.tags;
		return selectedTagIds.length > 0 && selectedTagIds.length <= MAX_TAG_COUNT;
	},

	showConfirmModal() {
		if (!CollectionDeleteCtrl.canDelete()) {
			CollectionDeleteCtrl.rejectCollectionDelete();
			return;
		}

		const confirmModal = new CollectionDeleteConfirmModal({
			title: T.COLLECTION_DELETE_TITLE,
			confirm: T.COLLECTION_DELETE,
			success: {
				key: T.COLLECTION_DELETE_SUCCESS,
				attrs: {
					count: CollectionDeleteCtrl.selectedCount,
				},
			},
		});

		confirmModal.open();
	},

	async deleteCollections() {
		if (!CollectionDeleteCtrl.canDelete()) {
			throw Error('Cannot delete collections');
		}

		const collectionSummaries = CurrentState.Tag.collections;
		await Services.Collection.remove(collectionSummaries);
	},

	rejectCollectionDelete() {
		NotificationService.warn({
			key: T.COLLECTION_DELETE_REJECT,
			attrs: {
				max: MAX_TAG_COUNT,
			},
		});
	},
};

class CollectionDeleteConfirmModal extends ModalFormComponent {
	get nodes(): MithrilVNode {
		return m('p', Translate(T.COLLECTION_DELETE_CONFIRM, CollectionDeleteCtrl.selectedCount));
	}

	override async submit() {
		await CollectionDeleteCtrl.deleteCollections();
	}
}
